import React from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Printer, Phone, Network, Wrench, Shield, Database, Globe, CheckCircle2, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Monitor: Monitor,
  Printer: Printer,
  Phone: Phone,
  Network: Network,
  Wrench: Wrench,
  Shield: Shield,
  Database: Database,
  Globe: Globe
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon];

  return (
    <div className={`bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300 border-l-4 ${service.borderColor} group h-full`}>
      {/* Icon */}
      <div className={`w-14 h-14 ${service.color} rounded-xl flex items-center justify-center mb-5`}>
        <IconComponent className={`w-7 h-7 ${service.iconColor}`} />
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>

      {/* Description */}
      <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>

      {/* Features */}
      <ul className="space-y-2 mb-5">
        {service.features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2 text-gray-700">
            <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" />
            <span className="text-sm">{feature}</span>
          </li>
        ))}
      </ul>

      {/* Link */}
      <Link 
        to={`/services/${service.slug}`}
        onClick={() => window.scrollTo(0, 0)}
        className={`inline-flex items-center gap-2 ${service.iconColor} font-semibold text-sm group-hover:gap-3 transition-all duration-200`}
      >
        Plus d'infos et tarifs détaillés
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Nos Services Professionnels
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des solutions complètes pour équiper et maintenir votre infrastructure informatique
          </p>
        </div>

        {/* Services Grid (flex + justify-center : la dernière rangée reste centrée) */}
        <div className="flex flex-wrap justify-center gap-6 lg:gap-8">
          {services.map((service) => (
            <div key={service.id} className="w-full md:w-[calc(50%-0.75rem)] lg:w-[calc((100%-4rem)/3)]">
              <ServiceCard service={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
